import React from 'react'
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Link } from "react-router";

export function MobileTopNav() {
  return (
    <nav className="md:hidden md:flex w-full h-12 flex flex-row justify-start items-center gap-2 px-4 border-b">
      <SidebarTrigger className="-ml-1" />
      <Link to="/app/">
        <span
          className="text-xl md:text-2xl font-extrabold tracking-tight rounded drop-shadow-sm text-foreground"
          aria-label="Tyto Bio"
        >
          Tyto Bio
        </span>
      </Link>
    </nav>
  )
}
